const KEY = 'recentlyViewedFabrics';
const MAX = 12;
export const RECENT_EVENT = 'recentlyViewedFabrics:change';
export const RECENT_LOCAL_EVENT = 'recentlyViewedFabrics:replaced';

export const getRecentlyViewed = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
};

// Records an enlarged swatch (most recent first, de-duplicated by id).
export const addRecentlyViewed = (color) => {
  if (!color?.id) return;
  const item = {
    id: color.id,
    name: color.name,
    code: color.code,
    hex_color: color.hex_color,
    image_url: color.image_url,
    brand_name: color.brand_name,
    collection_name: color.collection_name,
    material_name: color.material_name,
    webshop_url: color.webshop_url,
    viewed_at: Date.now(),
  };
  const items = [item, ...getRecentlyViewed().filter((c) => c.id !== color.id)].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(RECENT_EVENT));
};

// Replace the whole list (used when merging with the account copy). `silent` avoids re-triggering a sync.
export const replaceRecentlyViewed = (items, { silent = false } = {}) => {
  localStorage.setItem(KEY, JSON.stringify((items || []).slice(0, MAX)));
  window.dispatchEvent(new Event(silent ? RECENT_LOCAL_EVENT : RECENT_EVENT));
};

export const RECENT_CLEAR_EVENT = 'recentlyViewedFabrics:clear';

export const clearRecentlyViewed = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(RECENT_CLEAR_EVENT));
};
